import { initComponent } from './core/init-component';

initComponent('.js-ymal', (section) => {
  const url = section.dataset.url;

  if (!url) return;

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('.js-ymal-content');

      if (!content) return;

      section.innerHTML = content.outerHTML;
    })
    .catch(console.error);
});